const routes = [
    {
      path: '/en',
      name: 'Home',
      component: () => import('@/views/HomeView.vue'),
      meta: { title: 'Home' },
    },
    {
      path: '/all-dates',
      name: 'Dates',
      component: () => import('@/views/AllDatesView.vue'),
      meta: { title: 'All Events' },
    },
    {
      path: '/events-categories',
      name: 'Event categories',
      component: () => import('@/views/EventsCategoriesView.vue'),
      meta: { title: 'Events categories' },
    },
    {
      path: '/kategorie/:slug',
      name: 'Event category',
      component: () => import('@/views/EventCategoryView.vue'),
      meta: { title: 'Event category' },
    },
    {
      path: '/event-seats-booking',
      name: 'Event Seats Booking',
      component: () => import('@/views/EventSeatsBooking.vue'),
      meta: { title: 'Event Seats Booking' },
    },
    {
      path: '/event-tickets-booking',
      name: 'Event Ticket Booking',
      component: () => import('@/views/EventTicketsBooking.vue'),
      meta: { title: 'Event Tickets Booking' },
    },
    {
      path: '/vouchers',
      name: 'Vouchers',
      component: () => import('@/views/VouchersView.vue'),
      meta: { title: 'Vouchers' },
    },
    {
      path: '/artist-details',
      name: 'Artist details',
      component: () => import('@/views/ArtistDetailsView.vue'),
      meta: { title: 'Artist details' },
    },
    {
      path: '/locations',
      name: 'Locations',
      component: () => import('@/views/LocationsView.vue'),
      meta: { title: 'Locations' },
    },
    {
      path: '/cities/:city',
      name: 'City',
      component: () => import('@/views/CityView.vue'),
      meta: { title: 'City' },
    },
    {
      path: '/about-us',
      name: 'About Us',
      component: () => import('@/views/AboutUsView.vue'),
      meta: { title: 'About Us' },
    },
    {
      path: '/search-results',
      name: 'Search Results',
      component: () => import('@/views/SearchResultsView.vue'),
      meta: { title: 'Search Results' },
    },
    {
      path: '/account-overview',
      name: 'AccountOverview',
      component: () => import('@/views/AccountOverview.vue'),
      meta: {
        title: 'My Account',
        requiresAuth: true
      },
    },
{
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue'),
      meta: { title: 'Seite nicht gefunden' },
    }

  ];

  export default routes;
